/**
 * Create a linear regression chart.
 *
 * @param chartData The chart data
 * @param element The html element to render the chart in
 * @returns a promise with the chart reference
 */
export function createLinearChart() {
  // chartData: RegressionDataSet | null | undefined,
  // element: HTMLElement | undefined
  // return new Promise<XYChart | undefined>((resolve) => {
  //   Promise.all([
  //     import(/* webpackChunkName: "am4core" */ '@amcharts/amcharts4/core'),
  //     import(/* webpackChunkName: "am4charts" */ '@amcharts/amcharts4/charts'),
  //   ])
  //     .then((modules) => {
  //       if (chartData?.data) {
  //         const am4core = modules[0];
  //         const am4charts = modules[1];
  //         am4core.options.minPolylineStep = 5;
  //         const chart = am4core.create(element, am4charts.XYChart);
  //         chart.seriesContainer.zIndex = 10;
  //         const dataProvider = chartData.data.dataProvider;
  //         // V1 & V2 represent the names of the variables, and are the keys to the values
  //         const [v1, v2] = Object.keys(dataProvider[0]);
  //         chart.data = dataProvider;
  //         // Set the X axis
  //         const xAxis = chart.xAxes.push(new am4charts.ValueAxis());
  //         xAxis.title.text = v1;
  //         // Set the Y axis
  //         const yAxis = chart.yAxes.push(new am4charts.ValueAxis());
  //         yAxis.title.text = v2;
  //         // Create the series. We want a bullet chart, so we will use the line series,
  //         // set the stroke opacity to 0 to remove the lines, and add bullets.
  //         const series = chart.series.push(new am4charts.LineSeries());
  //         series.dataFields.valueY = v2;
  //         series.dataFields.valueX = v1;
  //         series.strokeOpacity = 0;
  //         // Add simple bullets
  //         const circleBullet = series.bullets.push(new am4core.Circle());
  //         circleBullet.radius = 1.5;
  //         circleBullet.disabled = true;
  //         circleBullet.propertyFields.disabled = 'isHidden';
  //         // Add a line series for the linear regression
  //         const regseries = chart.series.push(new am4charts.LineSeries());
  //         // y should be the dependent variable
  //         regseries.dataFields.valueY = v2;
  //         // x should be the independent variable
  //         regseries.dataFields.valueX = v1;
  //         regseries.strokeWidth = 2;
  //         regseries.name = $localize`Linear Regression`;
  //         // Need to set the start/end points of the line, so it'll map correctly
  //         regseries.data = [
  //           {
  //             [v1]: chartData.lineCoordinates?.xStart,
  //             [v2]: chartData.lineCoordinates?.yStart,
  //           },
  //           {
  //             [v1]: chartData.lineCoordinates?.xEnd,
  //             [v2]: chartData.lineCoordinates?.yEnd,
  //           },
  //         ];
  //         // add cursor
  //         chart.cursor = new am4charts.XYCursor();
  //         resolve(chart);
  //       }
  //     })
  //     .catch((e) => {
  //       console.error('Error when creating chart', e);
  //       resolve(undefined);
  //     });
  // });
}
